import React from 'react';
import classNames from 'classnames';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import { ValuePropItem, ValuePropsList } from '../../../../components/elements/ValuePropsList';
import { SectionPaddingSide, SectionPaddingVertical } from '../../../../components/global/Layout';
import Video from '../../../../components/global/Video';

const styles = require('./Skills.module.css');

const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

const skillsSectionData = {
  title: 'Crack the code on STEM & life skills',
  ctaLabel: 'Start 7-Day FREE Trial',
  videoUrl: 'https://dlnipn2r79d6o.cloudfront.net/global/video/ipad_video_app_demo_blue.mp4',
  skills: [
    'Innovative problem solving',
    'Increased confidence',
    'Persistence & resilience',
    'Boundless creativity',
    'Logical thinking',
  ],
};
const CTA_DATA_LOCATION = 'skills';

function SkillsSection({ onCtaClick }) {
  const { skills, title, videoUrl, ctaLabel } = skillsSectionData;

  const handleCtaClick = e => {
    onCtaClick(e, CTA_DATA_LOCATION);
  };

  return (
    <SectionPaddingVertical className={styles.skillsSection}>
      <SectionPaddingSide>
        <CodeSparkThemedTypography variant="h2" className={styles.skillsTitle}>
          {title}
        </CodeSparkThemedTypography>

        <div
          className={classNames('grid-x', 'grid-margin-x', 'align-middle', styles.skillsContent)}
        >
          <div className="cell small-12 large-7">
            <Video
              videoUrl={videoUrl}
              title="Problem Solving Video"
              autoPlay
              muted
              loop
            />
          </div>

          <div className={`cell small-12 large-5 ${styles.valuePropsWrapper}`}>
            <ValuePropsList className={styles.valuePropsList}>
              {skills.map((skill, i) => {
                return (
                  <ValuePropItem
                    key={`crack_skill_${i}`}
                    icon={`${imgURL}/flagship/how-it-works/single_star.png`}
                    iconSize="medium"
                  >
                    <CodeSparkThemedTypography variant="h4" className={styles.valuePropsItem}>
                      {skill}
                    </CodeSparkThemedTypography>
                  </ValuePropItem>
                );
              })}
            </ValuePropsList>

            <CtaButtonContainer className={styles.ctaContainer}>
              <CtaButton variant="primary" onClick={handleCtaClick}>
                {ctaLabel}
              </CtaButton>
            </CtaButtonContainer>
          </div>
        </div>
      </SectionPaddingSide>
    </SectionPaddingVertical>
  );
}

export default SkillsSection;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Skills/index.js